import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { sdd_collections_orchestrator as sddCollectionsOrchestrator } from '@repo/domain-types/transfers';
import { apiBaseURL } from 'receivable-invoices-js/constants/hosts';
import { qontoClient } from 'receivable-invoices-js/react/utils/api-clients/qonto';

const apiVersion = 'v1';
const sddCollectionsOrchestratorApi = sddCollectionsOrchestrator.mandates.firstparty.v1;

export type ApiCreatePublicMandateRequest =
  sddCollectionsOrchestrator.mandates.firstparty.v1.ApiCreatePublicMandateRequest;
export type ApiCreatePublicMandateResponse =
  sddCollectionsOrchestrator.mandates.firstparty.v1.ApiCreatePublicMandateResponse;

const getURL = (invitationLinkId: string) =>
  `${apiBaseURL}/${apiVersion}/direct_debit_collection_invitation_links/shared/${invitationLinkId}/mandates`;

export async function signMandatesInvitation(
  params: ApiCreatePublicMandateRequest
): Promise<ApiCreatePublicMandateResponse> {
  const url = getURL(params.invitationLinkId);

  const response = await qontoClient(url, {
    method: 'POST',
    body: sddCollectionsOrchestratorApi.ApiCreatePublicMandateRequest.toJSON(params) as object,
  });

  return sddCollectionsOrchestratorApi.ApiCreatePublicMandateResponse.fromJSON(response);
}

export type SignMandatesInvitationResponse = Awaited<ReturnType<typeof signMandatesInvitation>>;

export function useSignMandatesInvitation(
  options?: UseMutationOptions<SignMandatesInvitationResponse, Error, ApiCreatePublicMandateRequest>
) {
  return useMutation({
    mutationFn: signMandatesInvitation,
    ...options,
  });
}
